import styled, {css} from 'styled-components';
import {lightColor} from '@ey/styled-theme';

const lightMode = css`
	--form-element-border-color: var(--neutrals-900);
`;

const darkMode = css`
	--form-element-border-color: var(--neutrals-00white);
`;

export default styled.div`
	${({isDarkMode}) => (isDarkMode ? darkMode : lightMode)};
`;
